import React, { Component } from "react";

import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Creators as BenefitsActions } from "store/ducks/benefits";

import { Validate, Access } from "common";
import { Page, Breadcrumbs } from "components";
import { Form } from "pages/Benefits/components";
import { useDefaultDateFormat } from "helpers";

class Create extends Component {
  state = {
    data: {
      title: "",
      description: "",
      alias: "",
      experience_voucher_configuration_id: "",
      experience_commercial_campaigns_id: "",
      discount: "",
      value: 0,
      activation_period: true,
      store_channels: Access.lockedChannel()
        ? [Access.lockedChannel(true)]
        : [],
      store_channels_all: true,
      start_at: null,
      end_at: null,
      activation_limit: 0,
      app_only: false,
      cpf_list: [],
      promoted: false,
      extra_data: {
        store_region: null,
        store_places: Access.lockedStore() ? [Access.lockedStore(true)] : [],
        store_places_all: Access.lockedStore() ? false : true,
        classification_passions: [],
        classification_passions_all: true,
        store_product_types: Access.lockedProductType()
          ? [Access.lockedProductType(true)]
          : [],
        store_product_types_all: Access.lockedProductType() ? false : false,
        store_sections: [],
        store_sections_all: false,
        store_sub_sections: Access.lockedSection()
          ? [Access.lockedSection(true)]
          : [],
        store_sub_sections_all: Access.lockedSection() ? false : false,
        store_groups: [],
        store_sub_groups: [],
        cpf_list: [],
        remove_mdh: false,
        add_mdh: false,
        add_store_products: [],
        remove_store_products: [],
        send_email: false,
        all_products: false,
      },
    },
    errors: {},
    breadcrumbs: [
      { name: "Home", to: "/" },
      { name: "Benefícios", to: "/benefits" },
      { name: "Lista de Benefícios", to: "/benefits/list" },
      { name: "Adicionar Novo", to: "" },
    ],
  };

  handleChange = (data) => {
    const { errors } = this.state;

    this.setState({ data });

    Object.keys(errors).length && this.handleValidate();
  };

  handleValidate = () => {
    const { data } = this.state;

    const rules = {
      title: {
        required: true,
      },

      description: {
        required: true,
      },

      discount: {
        range: [1, 99]
      },

      start_at: {
        required: true,
      },

      end_at: {
        required: true,
      },
    };

    const validate = Validate(data, rules);

    this.setState({ errors: validate.errors });

    return validate.valid;
  };

  handleSave = () => {
    if (!this.handleValidate()) return null;

    const { data } = this.state;
    const { createBenefitRequest } = this.props;

    createBenefitRequest({
      voucher: {
        title: data.title,
        description: data.description,
        experience_voucher_configuration_id:
          data.experience_voucher_configuration_id.value,
        experience_commercial_campaigns_id:
          data.experience_commercial_campaigns_id.value,
        discount: data.discount,
        value:
          data.value === null || data.value === "" ? 0 : parseInt(data.value),
        activation_period: data.activation_period,
        start_at: useDefaultDateFormat(data.start_at),
        end_at: useDefaultDateFormat(data.end_at),
        activation_limit: data.activation_limit,
        store_channel_ids: !!data.store_channels_all
          ? []
          : data.store_channels.map((channel) => channel.value),
        alias: data.alias,
        app_only: data.app_only,
        cpf_list: data.cpf_list,
        promoted: data.promoted,
        extra_data: {
          store_region: data.extra_data.store_region,
          store_places: data.extra_data.store_places,
          store_places_all: data.extra_data.store_places_all,
          classification_passions: data.extra_data.classification_passions,
          classification_passions_all:
            data.extra_data.classification_passions_all,
          store_product_types: data.extra_data.store_product_types,
          store_product_types_all: data.extra_data.store_product_types_all,
          store_sections: data.extra_data.store_sections,
          store_sections_all: data.extra_data.store_sections_all,
          store_sub_sections: data.extra_data.store_sub_sections,
          store_sub_sections_all: data.extra_data.store_sub_sections_all,
          store_groups: data.extra_data.store_groups,
          store_sub_groups: data.extra_data.store_sub_groups,
          remove_mdh: data.extra_data.remove_mdh,
          add_mdh: data.extra_data.add_mdh,
          add_store_products: data.extra_data.add_store_products,
          remove_store_products: data.extra_data.remove_store_products,
          send_email: data.extra_data.send_email,
          all_products: data.extra_data.all_products,
        },
      },
    });
  };

  render() {
    const { data, errors, breadcrumbs } = this.state;
    const { create } = this.props;

    return (
      <Page>
        <Breadcrumbs breadcrumbs={breadcrumbs} />

        <Form
          data={data}
          errors={errors}
          saving={create.loading}
          onChange={this.handleChange}
          onSave={this.handleSave}
        />
      </Page>
    );
  }
}

const mapState = (state) => ({
  create: state.benefits.create,
});

const mapActions = (dispatch) => bindActionCreators(BenefitsActions, dispatch);

export default connect(mapState, mapActions)(Create);
